import { Control, useController } from 'react-hook-form'
import { Gewerk } from '@myapp/contract'
import { EntityMultiSelect } from '../../../shared/ui/search/EntityMultiSelect/EntityMultiSelect'
import { useGewerkeInfiniteQuery } from '../../../entities/gewerk'

interface Props {
  control: Control<any>
}

export function TradesMultiSelect({ control }: Props) {
  const { field } = useController({
    name: 'technicianProfile.trades',
    control,
  })

  const value: number[] = field.value ?? []

  return (
    <EntityMultiSelect<Gewerk>
      value={value}
      onChange={field.onChange}
      useInfiniteHook={useGewerkeInfiniteQuery}
      searchParamName="search"
      getLabel={(g) => g.text}
    />
  )
}
